import { IThemeProps } from "component/theme";
import styled from "styled-components";

export const StyledPickupLocationCard = styled('div')`
  ${({ theme }: IThemeProps) => ` 
    height: 100%;
    display: flex;
    flex-direction: column;

    .card-wrap {
      box-shadow: 4px 10px 30px 4px rgba(36, 14, 47, 0.06);
      border-radius: 12px;
      padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[12]}px;
      flex-grow: 1;
    }

    .uptime-delivery-card-body {
      min-height: 100px;
      width: 100%;
    }

    .MuiAutocomplete-popper {
      z-index: 9999999999999 !important;
    
      .MuiAutocomplete-option {
        font-size: 14px !important;
        font-weight: 400;
      }
    }

    .content-box {
      min-height: 80px;

      >p {
        margin: ${theme.uptimeSpace[0]}px;
      }
    }

    .heading5 {
      font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
      font-weight: normal;
      color: ${theme.uptimeColors.textColors.primary};
      margin: ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px;
    }

    .bodyRegular {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      display: block;
      line-height: 1.3;
      margin: ${theme.uptimeSpace[0]}px;
      color: ${theme.uptimeColors.grayScales.darkerGray};
    }

    .buttonLink {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
      font-weight: 600;
      text-transform: unset;
      padding: ${theme.uptimeSpace[0]}px;
      color: ${theme.uptimeColors.generalColors.button.hyperlink.enabled};
      float: right;
      background-color: transparent !important;
      text-decoration: none;
      font-family: ${`'${theme.uptimeFonts.primary}'`} !important;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      &:hover {
        text-decoration: underline;
        color: ${theme.uptimeColors.generalColors.button.hyperlink.hover};
      }
    }
  `}
`;
